<div class="cell-container" [class.readonly]="readonly" [style.background]="color" >
    <ng-container *ngIf="readonly | equals:false; else readonlyContent">
        <input #input 
            [class.percent]="type | equals:'percent'" type="text" 
            [ngModel]="value | formatCellValue:type" 
            [placeholder]="default | formatCellValue:type | default: ''" 
            [readonly]="readonly"
            [ngModelOptions]="{updateOn:'blur'}" 
            (ngModelChange)="_handleModelChange($event)"
            (mousedown)="_handleClick($event)" 
            (focus)="_handleFocus($event)" 
            (change)="_purgeEvent($event)"
            (blur)="_handleBlur($event)" 
            (keydown)="_handleKeydown($event)" 
            (copy)="_purgeEvent($event)" 
            (cut)="_purgeEvent($event)" 
            (paste)="_purgeEvent($event)"/>
    </ng-container>
    <ng-template #readonlyContent>
        <div class="content" [class.default]="(value | exists | not) | and: (default | exists)">{{ value | default: default | formatCellValue:type }}</div>
    </ng-template>
</div>